import React from 'react';
import { Box, SxProps, Theme, Tooltip, Typography, TypographyTypeMap } from '@mui/material';
import { useTranslation } from "react-i18next";
import FittedText from './FittedText';

export type ISONumberProps = {
  number: number;
  fitToContainer?: boolean;
  maxFitToContainerFontSize?: number;
  options?: Intl.NumberFormatOptions;
  typographyVariant?: TypographyTypeMap | string;
  typographyComponent?: string;
  includeDecimals?: boolean;
  sx?: SxProps<Theme> | undefined;

  prefix?: string;
  prefixSize?: string;
  postfix?: string;
  postfixSize?: string;
};

export default function ISONumber(props: ISONumberProps): React.JSX.Element {
  const { i18n } = useTranslation();
  const t = i18n.t;
  const variant:any = props.typographyVariant || "body1",
      typographyComponent:any = props.typographyComponent || "span";

  const prefixSize = props.prefixSize || "0.7em";
  const postfixSize = props.postfixSize || "0.7em";

  const number = t("intlNumber", {
    val: props.includeDecimals ? props.number : Math.round(props.number),
    formatParams: {
      val: props.options || {}
    }
  });

  // Get css settings for color and alignment to use for the FittedText component
  const displayColor = props.sx?.color || undefined;
  let horizontalAlignment = props.sx?.textAlign || props.sx?.justifyContent || undefined;
  if (horizontalAlignment === "start" || horizontalAlignment === "flex-start") {
    horizontalAlignment = "left";
  } else if (horizontalAlignment === "end" || horizontalAlignment === "flex-end") {
    horizontalAlignment = "right";
  }

  return (
    <Box>
      {props.fitToContainer &&
        <Box
          sx={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0
          }}>
            <FittedText content={number} color={displayColor} horizontalAlignment={horizontalAlignment} 
              prefix={props.prefix}
              prefixSize={prefixSize}
              postfix={props.postfix}
              postfixSize={postfixSize}
            />
        </Box>
      }
      {!props.fitToContainer &&
        <Typography
          variant={variant}
          component={typographyComponent}
          sx={props.sx}
        >
          {props.prefix && <span style={{ fontSize: prefixSize, verticalAlign: "middle"  }}>{props.prefix}</span>}    
          <span style={{verticalAlign:"middle"}}>{number}</span>
          {props.postfix && <span style={{ fontSize: postfixSize, verticalAlign: "middle"  }}>{props.postfix}</span>}
        </Typography>
      }
    </Box>
  );
}